import { render, staticRenderFns } from "./grupos.vue?vue&type=template&id=3770e03a"
import script from "./grupos.vue?vue&type=script&lang=js"
export * from "./grupos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports